import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import BlogWeet from "../assets/projectImages/BlogWeet.png";
import ExplorePlaces from "../assets/projectImages/ExplorePlaces.png";
import ExtraSpace from "../assets/projectImages/ExtraSpace.png";
import FrontendAuth from "../assets/projectImages/FrontendAuthorization.png";
import Meetups from "../assets/projectImages/MeetUps.png";
import PortfolioV1 from "../assets/projectImages/Portfolio.png";
import QuotationMaker from "../assets/projectImages/QuotationMaker.png";
import TodoApp from "../assets/projectImages/TodoApp.png";
// import CurrencyConverter from "../assets/projectImages/CurrencyConverter.png";
import erp from "../assets/projectImages/erp.png";
import tas from "../assets/projectImages/TAS_app.png";

// import hr from "../assets/curve-hr.svg";
import CardWrapper from "./CardWrapper/CardWrapper.js";
import { useEffect, useState } from "react";

export default function Projects1() {
  const [showAllCards, setShowAllCards] = useState(false);
  const [slides, setSlides] = useState(3);

  const toggleCardsVisibility = () => {
    setShowAllCards(!showAllCards);
  };
  useEffect(() => {
    // eslint-disable-next-line no-restricted-globals
    const width = screen.width;
    if (width < 500) {
      setSlides(1);
    }
  }, []);
  const settings = {
    dots: false,
    autoplay: true,
    infinite: true,
    slidesToShow: slides,
    slidesToScroll: 1,
  };

  return (
    <div id="projects" className="mt-4 text-white">
      <div className="flex justify-between">
        <div>
          <h1 className="text-2xl font-bold">Projects</h1>
          <p className="font-light text-gray-400">
            Here are some of my projects
          </p>
        </div>
        <div>
          <button onClick={toggleCardsVisibility}>
            {showAllCards ? "Show Carousel" : "Show All"}
          </button>
        </div>
      </div>
      {showAllCards ? (
        <div className="flex flex-wrap justify-between">
          {/* Render all the cards flex flex-wrap justify-around*/}
          <CardWrapper
            src={erp}
            title="Campus Pro"
            subtitle="Enterprise Resource Planning for Educational Institutions - A centralized web application for a college that streamlines administrative processes, manages student data, exams, fees, and attendance."
            glink="https://github.com/AKD-01/"
            vlink="https://campuspro.vercel.app/"
          />
          <CardWrapper
            src={BlogWeet}
            title="BlogWeet"
            subtitle="BlogWeet is a user-friendly social media app that empowers individuals of all ages to create, share, and engage with blog posts, fostering a vibrant community of diverse perspectives."
            glink="https://github.com/AKD-01/blogweet"
            vlink="https://blogweet.vercel.app/"
          />
          <CardWrapper
            src={ExtraSpace}
            title="ExtraSpace"
            subtitle="A cloud where users can make folders, upload all types of files and links, making it easier to keep everything organised and secure with security of Google's Firebase. "
            glink="https://github.com/akd-01/Extraspace-Cloud"
            vlink="https://extraspace-cloud.netlify.app/"
          />
          <CardWrapper
            src={tas}
            title="Team Availability Status"
            subtitle="A web application for team members to register, log in, and update their daily availability or leave status."
            glink="https://github.com/AKD-01/"
            vlink="https://teamavailabilitystatus.vercel.app/"
          />
          <CardWrapper
            src={ExplorePlaces}
            title="ExplorePlaces"
            subtitle="A web-based application made with React JS, where users can find places to explore or can add the places which they want others to explore. "
            glink="https://github.com/AKD-01/Explore-Places"
            vlink="http://explore-places.vercel.app/"
          />
          <CardWrapper
            src={PortfolioV1}
            title="Portfolio"
            subtitle="My Personal Portfolio. "
            glink="https://github.com/akd-01"
            vlink="https://akd-01-github-io.vercel.app/"
          />
          <CardWrapper
            src={TodoApp}
            title="Todo App"
            subtitle="An app where one can add and keep track of their todos."
            glink="https://github.com/AKD-01/Todo-App"
            vlink="https://todo-akd.vercel.app/"
          />
          <CardWrapper
            src={FrontendAuth}
            title="Frontend Authorization Template"
            subtitle="A template for Frontend-Authorization."
            glink="https://github.com/AKD-01/frontend-authorization"
            vlink="https://frontend-authorization.vercel.app"
          />
          <CardWrapper
            src={Meetups}
            title="Meetups"
            subtitle="A website where anyone can organize meets. Made with reactjs and firebase!"
            glink="https://github.com/AKD-01/Meetup"
            vlink="https://meetup01.vercel.app/"
          />
          <CardWrapper
            src={QuotationMaker}
            title="Quotation Maker"
            subtitle="Sample Quotation Maker"
            glink="https://github.com/AKD-01/Quotation-Maker"
            vlink="https://quotation-maker.vercel.app/"
          />
        </div>
      ) : (
        // flex flex-wrap justify-around
        <div className="mt-4">
          <Slider {...settings}>
            <CardWrapper
              src={erp}
              title="Campus Pro"
              subtitle="Enterprise Resource Planning Application - A centralized web application for a college that streamlines administrative processes, manages student data, exams, fees, and attendance."
              glink="https://github.com/AKD-01/"
              vlink="https://campuspro.vercel.app/"
            />
            <CardWrapper
              src={BlogWeet}
              title="BlogWeet"
              subtitle="BlogWeet is a user-friendly social media app that empowers individuals of all ages to create, share, and engage with blog posts, fostering a vibrant community of diverse perspectives."
              glink="https://github.com/AKD-01/blogweet"
              vlink="https://blogweet.vercel.app/"
            />
            <CardWrapper
              src={ExtraSpace}
              title="ExtraSpace"
              subtitle="A cloud where users can make folders, upload all types of files and links, making it easier to keep everything organised and secure with security of Google's Firebase."
              glink="https://github.com/akd-01/Extraspace-Cloud"
              vlink="https://extraspace-cloud.netlify.app/"
            />
            <CardWrapper
              src={tas}
              title="Team Availability Status"
              subtitle="A web application for team members to register, log in, and update their daily availability or leave status."
              glink="https://github.com/AKD-01/"
              vlink="https://teamavailabilitystatus.vercel.app/"
            />
            <CardWrapper
              src={ExplorePlaces}
              title="ExplorePlaces"
              subtitle="A web-based application made with React JS, where users can find places to explore or can add the places which they want others to explore. "
              glink="https://github.com/AKD-01/Explore-Places"
              vlink="http://explore-places.vercel.app/"
            />
            <CardWrapper
              src={PortfolioV1}
              title="Portfolio"
              subtitle="My Personal Portfolio."
              glink="https://github.com/akd-01"
              vlink="https://akd-01-github-io.vercel.app/"
            />
            <CardWrapper
              src={TodoApp}
              title="Todo App"
              subtitle="An app where one can add and keep track of their todos.  "
              glink="https://github.com/AKD-01/Todo-App"
              vlink="https://todo-akd.vercel.app/"
            />
            <CardWrapper
              src={FrontendAuth}
              title="Frontend Authorization Template"
              subtitle=" A template for Frontend-Authorization . "
              glink="https://github.com/AKD-01/frontend-authorization"
              vlink="https://frontend-authorization.vercel.app"
            />
            <CardWrapper
              src={Meetups}
              title="Meetups"
              subtitle="A website where anyone can organize meets. Made with reactjs and firebase!"
              glink="https://github.com/AKD-01/Meetup"
              vlink="https://meetup01.vercel.app/"
            />
            <CardWrapper
              src={QuotationMaker}
              title="Quotation Maker"
              subtitle="Sample Quotation Maker"
              glink="https://github.com/AKD-01/Quotation-Maker"
              vlink="https://quotation-maker.vercel.app/"
            />
            {/* <CardWrapper
              src={CurrencyConverter}
              title="Currency Converter"
              subtitle="A website that allows users to convert one currency to another."
              glink="https://github.com/AKD-01/convert-a-currency"
              vlink="https://convertcurrency.vercel.app/"
            /> */}
          </Slider>
        </div>
      )}
      <div className="line"></div>
      {/**<img src={hr} className="w-full mt-8 md:h-3" alt="hr" />*/}
    </div>
  );
}
